'use strict';

document.addEventListener('DOMContentLoaded', () => {
  // popup cookie
  const popupCookie = document.querySelector('.popup-cookie');
  const popupCookieButton = document.querySelector('.popup-cookie__button');
  const cookieView = localStorage.getItem('cookie');

  if(!cookieView) {
    popupCookie.classList.add('popup--open');
  }

  popupCookieButton.addEventListener('click', () => {
    localStorage.setItem('cookie', true);
    popupCookie.classList.remove('popup--open');
  });

  // popup brand
  const popupBrand = document.querySelector('.popup-brand');
  const popupClose = document.querySelector('.popup-brand__close');

  if(popupBrand) {
    document.body.addEventListener('click', (e) => {
      if(e.target.closest('.js-popup-brand')) {
        e.preventDefault();
        popupBrand.classList.add('popup--open');
      }
    });

    ['click', 'touchstart'].forEach((event) => {
      window.addEventListener(event, (e) => {
        if(e.target === popupBrand) {
          popupBrand.classList.remove('popup--open');
        }
      });
    });

    popupClose.addEventListener('click', () => {
      popupBrand.classList.remove('popup--open');
    });
  }
});